import { api } from "..";

interface BanUserPayload {
  userId: number;
  reason?: string | null;
  expiresAt?: string | null;
}

interface UnbanUserPayload {
  userId: number;
}

export async function banUser(
  payload: BanUserPayload
): Promise<{ success: boolean }> {
  const { userId, ...body } = payload;
  const res = await api.client.put(`/users-new/${userId}/ban`, body);
  return res.data;
}

export async function unbanUser(
  payload: UnbanUserPayload
): Promise<{ success: boolean }> {
  const res = await api.client.delete(`/users-new/${payload.userId}/ban`);
  return res.data;
}
